import { render, staticRenderFns } from "./ChangeAdmin.vue?vue&type=template&id=1b777d14&"
import script from "./ChangeAdmin.vue?vue&type=script&lang=ts&"
export * from "./ChangeAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports